import { get } from "./AxiosMethods";

export default class WBKonfigurator {
    static searchDummy(queryData) {
        return get("/api/wbksearch/SearchDummy", queryData);
    }
    static getDetail(id) {
        return get("/api/wbksearch/GetDetail", { id });
    }
    static getPossiblyCompletedCourses(searchTerm) {
        return get("/api/wbksearch/GetPossiblyCompletedCourses",{searchTerm});
    }
    static searchByCompletedCourses(courseId) {
        return get("/api/wbksearch/SearchByCompletedCourses", { ids: [courseId], text: ""});
    }
    static searchByTopic(query, types) {
        var q = {
            text: query
        }
        if (types.length) {
            q.types = types
        }
        return get("/api/wbksearch/SearchByTopic", q);
    }
}